import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import {
    L10N_CONFIG,
    L10N_LOCALE,
    L10nConfig,
    L10nLocale,
    L10nTranslatePipe,
    L10nTranslationService
} from 'angular-l10n';
import { AuthService } from '../shared/auth.service';
import { Kernantwort } from '../shared/response/kernantwort.model';

import { CommonModule } from "@angular/common";
import { AngularMaterial2Module } from "../app.module.material";


@Component({
    templateUrl: './signup.component.html',
    standalone:true,
	imports: [AngularMaterial2Module, L10nTranslatePipe, CommonModule, ReactiveFormsModule ]

})
export class SignupComponent implements OnInit {
    signupForm: FormGroup;
    error = false;
    errorMessage = '';
    fehler: Kernantwort = null;


    constructor(private fb: FormBuilder,
				public authService: AuthService,
				@Inject(L10N_LOCALE) public locale: L10nLocale,
				@Inject(L10N_CONFIG) private config: L10nConfig,
				public translation: L10nTranslationService,
				public title: Title) {
		this.title.setTitle(this.translation.translate('register.title') + ' - ' + this.translation.translate('project.title'));
    }

    onSignup() {
      this.authService.signupUser(this.signupForm.value);
    }

    ngOnInit(): any {
        this.signupForm = this.fb.group({
            user: ['', Validators.required],
            password: ['', Validators.required],
            confirmPassword: ['', Validators.compose([
                Validators.required,
                this.isEqualPassword.bind(this)
            ])],
        });
    }

    isEmail(control: FormControl): {[s: string]: boolean} {
        if (!control.value.match(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/)) {
            return {noEmail: true};
        }
    }

    isEqualPassword(control: FormControl): {[s: string]: boolean} {
        if (!this.signupForm) {
            return {passwordsNotMatch: true};

        }
        if (control.value !== this.signupForm.controls['password'].value) {
            return {passwordsNotMatch: true};
        }
    }
}
